<template>
  <div class="jingpin-box">
    <div v-if="list && list.length > 0" class="home-two-title">
      <div class="text">
        <slot>最近直播</slot>
       </div>
      <span class="more" @click="zhibokes">查看更多&nbsp;></span>
    </div>
    <div v-if="list && list.length > 0" class="jingpin">
      <div v-for="(item, index) in list" :key="index" class="item">
        <div class="time-tips">
          {{ item.startTime | format("MM月dd日 HH:mm") }} 开播
        </div>

        <img class="item-img" :src="item.img">
        <div class="detail">
          <div class="detail-title twoEllipsis">{{ item.title }}</div>

          <div class="detail-ter flex-between-c m-t-20">
            <div class="ter-list">
              <div class="terbox">
                <el-image class="ter-img" :src="item.teacherImg" fit="cover" />
              </div>
              <span class="ter">讲师：{{ item.teacherName }}</span>
            </div>
            <div class="tips">人气值 {{ item.clicks ? item.clicks : 0 }}</div>
          </div>
          <div v-if="item.isLive == 3" class="keep-learn" @click="godetail(item)">
            观看回放
          </div>
          <div v-else class="keep-learn" @click="godetail(item)">立即观看</div>
        </div>
      </div>
    </div>
    
   
  </div>
</template>
<script>
import '@/assets/css/common.css'
 
import Vue from 'vue' 
import { getInfo } from '@/api/cookies' 
import { HomeClient } from "@/api/home"; 
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      userInfo: null,
      list: [],
      liveId: null,
      ifHave: false,
      liveshowName: '',
      live: null,
      lookDeatil: null,
      showLookDetail: false
    }
  },
  created() {
    this.userInfo = getInfo()
    homeClient.getLiveshowplaybackByTypes({pageSize:5, pageNum:1}).then((res) => {
      this.list = res.data.rows
    })
  },
  methods: {
    zhibokes() {
      this.$router.push({ name: '直播课' })
    },

    async godetail(item) {
       if (!this.userInfo) {
        Vue.prototype.goLoginView(true)
        return
      }
      this.liveId = item.liveId
    },
   

   
  }
}
</script>
<style lang="less" scoped>
.jingpin {
  width: 1222px;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .item {
    margin-bottom: 24px;
    width: 224px;
    height: 315px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-right: 20px;
    overflow: hidden;
    position: relative;

    &:last-child {
      margin-right: 0px;
    }

    .time-tips {
      position: absolute;
      width: 154px;
      height: 24px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 8px 0px 8px 0px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
      text-align: center;
    }

    &:hover {
      box-shadow: 0px 4px 8px 1px rgba(153, 153, 153, 0.20000000298023224);
    }

    .item-img {
      width: 100%;
      height: 126px;
      border-radius: 8px 8px 0px 0px;
      opacity: 1;
    }

    .detail {
      padding: 12px 16px;

      .detail-title {
        height: 48px;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }

      .tips {
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
      }
    }
  }
}

.home-two-title {
  padding: 28px 0px 4px;
  width: 1220px;
}

.detail-ter {
  .ter {
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 12px;
  }
}

.keep-learn {
  position: absolute;
  bottom: 16px;
  width: 192px;
  height: 30px;
  background: #ff5e51;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}
</style>
